export default {
  blue: '#12566D',
  blueLight: '#39C1EE',
  green: '#9EDA51',
  orange: '#FF8400',
  grey: '#ECEFF1',
  brown: '#505050',
  red: '#f0566d'
};
